import { fetchCommonData } from "@/services/CommonService";
import ProgramPage from "./programs/[program]";
import SchoolPage from "./schools/[school]";
import UGPGPage from "./ug-pg-page/[ugpg]";
import {
  CmsCoursePages,
  CmsSchoolPages,
  CmsUgpgPages,
} from "@/services/CmsService";

const SlugPage = ({ type, data, slug, cmsData, commonData }: any) => {
  if (type === "program") {
    return (
      <ProgramPage
        programData={data}
        slug={slug}
        cmsData={cmsData}
        commonData={commonData}
      />
    );
  }

  if (type === "school") {
    return (
      <SchoolPage
        schoolData={data}
        slug={slug}
        cmsData={cmsData}
        commonData={commonData}
      />
    );
  }

  if (type === "ugpg") {
    return <UGPGPage cmsData={cmsData} commonData={commonData} />;
  }
  return <h1>404 - Page Not Found</h1>;
};

export async function getServerSideProps({ params }: any) {
  const { slug } = params;

  const response = await fetchCommonData();

  const ProgramPageDatas = await CmsCoursePages(params);
  const SchoolPageData = await CmsSchoolPages(params);
  const UgpgPageData = await CmsUgpgPages(params);

  const Programpage = ProgramPageDatas.data?.find((p: any) => p.slug === slug);
  const Schoolpage = SchoolPageData.data?.find((p: any) => p.slug === slug);
  const UgpgPage = UgpgPageData.data?.find((p: any) => p.slug === slug);

  if (Schoolpage) {
    return {
      props: {
        type: "school",
        slug,
        cmsData: Schoolpage || null,
        commonData: response.data || null,
      },
    };
  }

  if (UgpgPage) {
    return {
      props: {
        type: "ugpg",
        slug,
        cmsData: UgpgPage,

        commonData: response.data,
      },
    };
  }

  if (Programpage)
    return {
      props: {
        type: "program",
        slug,
        cmsData: Programpage || null,
        commonData: response.data || null,
      },
    };

  return {
    notFound: true,
  };
}

export default SlugPage;
